import { getRoles, getRolesAxios } from '@/api/user.js';
import constants from '@/constants';
import { sortByName } from '@/scripts/tools';

export default {
    state: {
        constPermissions: constants.PERMISSIONS,

        roles: [],

        isShowRoleEdit: false,
        isSaveRoleEdit: false,
        roleEditData: null,

        isShowRoleAdd: false,
        isSaveRoleAdd: false,
        roleAddData: {
            name: '',
            can_activate_users: false,
            can_add_roles: false,
            can_assign_roles: false,
            can_delete_files: false,
            can_delete_games: false,
            can_edit_asset_types: false,
            can_edit_files: false,
            can_edit_filters: false,
            can_edit_games: false,
            can_edit_prompts: false,
            can_edit_providers: false,
            can_edit_smart_filters: false,
            can_edit_tags: false,
            can_release_files: false,
            can_use_admin: false,
            can_manage_publishers: false,
        },
    },
    getters: {
        ROLES: (state) => {
            return state.roles;
        },
        ROLES_BY_ID: (state) => (id) => {
            const role = state.roles.find((role) => role.id === id);
            return role == null ? {} : role;
        },

        IS_SHOW_ROLE_EDIT: (state) => {
            return state.isShowRoleEdit;
        },
        IS_SAVE_ROLE_EDIT: (state) => {
            return state.isSaveRoleEdit;
        },
        ROLE_EDIT_DATA: (state) => {
            return state.roleEditData;
        },

        IS_SHOW_ROLE_ADD: (state) => {
            return state.isShowRoleAdd;
        },
        IS_SAVE_ROLE_ADD: (state) => {
            return state.isSaveRoleAdd;
        },
        ROLE_ADD_DATA: (state) => {
            return state.roleAddData;
        },

        CONST_PERMISSIONS: (state) => {
            return state.constPermissions;
        },
    },
    mutations: {
        ROLES: (state, payload) => {
            payload.sort((a, b) => sortByName(a, b));
            state.roles = payload;
        },
        ROLES_ADD: (state, payload) => {
            state.roles.push(payload);
        },
        ROLES_UPDATE: (state, { id, payload }) => {
            const roleIndex = state.roles.map((role) => role.id).indexOf(id);
            if (roleIndex < 0) return;

            state.roles[roleIndex] = structuredClone(payload);
        },
        ROLE_SPLIT: (state, id) => {
            const roleIndex = state.roles.map((role) => role.id).indexOf(id);
            if (roleIndex >= 0) state.roles.splice(roleIndex, 1);
        },

        IS_SHOW_ROLE_EDIT: (state, payload) => {
            state.isShowRoleEdit = payload;
        },
        IS_SAVE_ROLE_EDIT: (state, payload) => {
            state.isSaveRoleEdit = payload;
        },
        ROLE_EDIT_SET: (state, payload) => {
            state.roleEditData = structuredClone(payload);
        },
        ROLE_EDIT_UPDATE: (state, { fieldName, fieldValue }) => {
            state.roleEditData[fieldName] = fieldValue;
        },

        IS_SHOW_ROLE_ADD: (state, payload) => {
            state.isShowRoleAdd = payload;
        },
        IS_SAVE_ROLE_ADD: (state, payload) => {
            state.isSaveRoleAdd = payload;
        },
        ROLE_ADD_UPDATE: (state, { fieldName, fieldValue }) => {
            state.roleAddData[fieldName] = fieldValue;
        },
    },
    actions: {
        CHECK_ROLES: async function (context) {
            if (context.getters.ROLES.length === 0) {
                context.commit('ROLES', await getRoles());
            }
        },
        CHECK_ROLES_AXIOS: async function (context) {
            if (context.getters.ROLES.length === 0) {
                const axiosPromise = await getRolesAxios().catch((error) => {
                    return null;
                });
                return axiosPromise;
            }
            return null;
        },
        CHECK_ROLE_ADD: async function (context) {
            const roleData = context.getters.ROLE_ADD_DATA;

            if (roleData.name === '') {
                context.commit('IS_SAVE_ROLE_ADD', false);
                return 'To create a role, you must enter a name';
            }

            context.commit('IS_SAVE_ROLE_ADD', true);
            return '';
        },
        CHECK_ROLE_EDIT: async function (context) {
            const roleData = context.getters.ROLE_EDIT_DATA;

            if (roleData.name === '') {
                context.commit('IS_SAVE_ROLE_EDIT', false);
                return 'To save the role, enter a name';
            }

            context.commit('IS_SAVE_ROLE_EDIT', true);
            return '';
        },
    },
};
